import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { ISalesTeam } from '@user/store/salesTeam'
import React from 'react'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { LightTooltip } from '@sales-center/components'
import { salesTeamNoPosition } from '../constants'
type Props = {
  props: React.HTMLAttributes<HTMLLIElement>
  option: ISalesTeam
}

export default function SalesTeamSelectItem({ props, option }: Props) {
  const tidalThemeActive = useTidalThemeActive()

  const height = tidalThemeActive ? '52px' : '33px'

  if (option?.positions?.length == 0) {
    return (
      <LightTooltip title={salesTeamNoPosition}>
        <Box component="span">
          <MenuItem
            {...props}
            onClick={(e) => e.preventDefault()}
            disabled
            sx={{
              height: height,
              minHeight: height,
              position: 'relative',
              '&.Mui-disabled': {
                pointerEvents: 'auto',
              },
            }}
            key={option.id}
          >
            <Box display="flex" justifyContent={'space-between'} flexGrow={1}>
              <Typography display="inline" variant="body1">
                {option.name}
              </Typography>
            </Box>
          </MenuItem>
        </Box>
      </LightTooltip>
    )
  }

  return (
    <MenuItem
      {...props}
      sx={{
        height: height,
        minHeight: height,
        position: 'relative',
      }}
      key={option.id}
    >
      <Box display="flex" justifyContent={'space-between'} flexGrow={1}>
        <Typography display="inline" variant="body1">
          {option.name}
        </Typography>
      </Box>
    </MenuItem>
  )
}
